export default {
  VAULT_OPENED: 'Vault Opened',
  VAULT_CONFIGURATOR_RELAUNCHED: 'Vault Configurator Re-launched',
  VAULT_CONFIGURATOR_LAUNCHED: 'Vault Configurator Launched',
  // new events
  REQUEST_INFO_FROM_CLIENT_CLICKED: 'Request Info From Client Clicked',
  VAULT_SHARE_COPY_LINK_CLICKED: 'Vault Share Copy Link Clicked',
  VAULT_SHARE_EMAIL_ATTEMPTED: 'Vault Share Email Attempted',
  VAULT_SHARE_EMAIL_COMPLETED: 'Vault Share Email Completed',
  VAULT_SHARE_EMAIL_FAILED: 'Vault Share Email Failed',
  VAULT_SHARE_WHATSAPP_CLICKED: 'Vault Share WhatsApp Clicked',
  VAULT_DOCUMENTS_CHECKLIST_SAVE_ATTEMPTED: 'Vault Documents Checklist Save Attempted',
  VAULT_DOCUMENTS_CHECKLIST_SAVE_COMPLETED: 'Vault Documents Checklist Save Completed',
  VAULT_DOCUMENTS_CHECKLIST_SAVE_FAILED: 'Vault Documents Checklist Save Failed',
  CASE_CLIENT_REQUESTED_INFO_VIEWED: 'Case Client-Requested Info Viewed',
  CASE_CLIENT_REQUESTED_INFO_SAVE_ATTEMPTED: 'Case Client-Requested Info Save Attempted',
  CASE_CLIENT_REQUESTED_INFO_SAVE_COMPLETED: 'Case Client-Requested Info Save Completed',
  CASE_CLIENT_REQUESTED_INFO_SAVE_FAILED: 'Case Client-Requested Info Save Failed',
  CASE_CLIENT_REQUESTED_INFO_SUBMIT_CLICKED: 'Case Client-Requested Info Submit Clicked',
  CASE_CLIENT_REQUESTED_INFO_SUBMIT_ATTEMPTED: 'Case Client-Requested Info Submit Attempted',
  CASE_CLIENT_REQUESTED_INFO_SUBMIT_CANCELED: 'Case Client-Requested Info Submit Canceled',
  CASE_CLIENT_REQUESTED_INFO_SUBMIT_COMPLETED: 'Case Client-Requested Info Submit Completed',
  CASE_CLIENT_REQUESTED_INFO_SUBMIT_FAILED: 'Case Client-Requested Info Submit Failed',
};
